import { Injectable, EventEmitter } from '@angular/core'

import { UserTask } from '@mprep/shared/data/models'

@Injectable()
export class MessagingService {
  public optionalTaskToggle: EventEmitter<any>

  constructor() {
    this.optionalTaskToggle = new EventEmitter()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/messaging.service.ts